export default __webpack_public_path__ + "static/media/document.e029069f.png";